import { useQueryDAILicenseMetadata } from '../../../../../aiem/daiLicense.hooks';
import type { Date as ProtoDate } from '../../../../../aiem/gen/google/type/date_pb';

const protoDateToDate = (date: ProtoDate | undefined): Date | null => {
  if (!date?.year || !date?.month || !date?.day) return null;
  return new Date(date.year, date.month - 1, date.day);
};

const EXPIRATION_WARNING_DAYS = 30;
const MS_PER_DAY = 1000 * 60 * 60 * 24;

export const useDAILicenseExpiration = (enabled: boolean) => {
  const { data: daiLicenseMetadata } = useQueryDAILicenseMetadata({ enabled });

  const expirationDate = protoDateToDate(daiLicenseMetadata?.expirationDate);
  const daysUntilExpiration = expirationDate ? Math.ceil((expirationDate.getTime() - Date.now()) / MS_PER_DAY) : null;
  const showWarning = enabled && daysUntilExpiration !== null && daysUntilExpiration <= EXPIRATION_WARNING_DAYS;

  return { daysUntilExpiration, showWarning };
};
